import { EventRegister } from "@common/events/event-register"
import loginEvents from "./events"
import eventHandlers from "./event-handlers"
import asclepiusApiEvents from "@common/composables/api/asclepius-api-events"

export const registerEventListeners: EventRegister = (eventBus) => {
  eventBus.$on(loginEvents.LOG_IN, eventHandlers.handleLogInEvent)
  eventBus.$on(loginEvents.LOG_OUT, eventHandlers.handleLogOutEvent)
  eventBus.$on(asclepiusApiEvents.ACCESS_TOKEN_REFRESHED, eventHandlers.handleAccessTokenRefreshed)
  eventBus.$on(
    asclepiusApiEvents.UNAUTHENTICATED_API_ERROR_RESPONSE_RECEIVED,
    eventHandlers.handleUnauthenticatedApiResponse
  )
}
